module.exports = __webpack_public_path__ + "img/City.fe37ca6e.svg";